import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "iconfont ic_shousuo" }, null, -1);
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", null, "收起", -1);
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("i", { class: "iconfont ic_quanping" }, null, -1);
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", null, "全屏", -1);
import { onMounted, onUnmounted, ref } from 'vue';
import { ElMessage } from 'element-plus';
import screenfull from 'screenfull';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScreenFull',
    setup: function (__props) {
        onMounted(function () {
            if (screenfull.isEnabled) {
                screenfull.on('change', changeEvent);
            }
        });
        var isFullscreen = ref(false);
        var screenToggle = function () {
            if (!screenfull.isEnabled) {
                ElMessage.warning('您的浏览器不支持全屏功能');
                return false;
            }
            screenfull.toggle();
        };
        var changeEvent = function () {
            isFullscreen.value = screenfull.isFullscreen;
        };
        onUnmounted(function () {
            // 删除监听器
            if (screenfull.isEnabled) {
                screenfull.off('change', changeEvent);
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("span", {
                onClick: screenToggle,
                class: "cursor-pointer"
            }, [
                (isFullscreen.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_1,
                        _hoisted_2
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_3,
                        _hoisted_4
                    ], 64))
            ]));
        };
    }
});
